import { MinusIcon, PlusIcon } from 'lucide-react'

import { cn } from '../../lib/utils'
import { Button } from '../button'
import { Input } from '../input'

type CounterProps = {
  decreaseLabel: string
  increaseLabel: string
  inputLabel: string
  onValueChange: (value: number) => void
  value: number
  className?: string
  min?: number
}

export const Counter = ({
  decreaseLabel,
  increaseLabel,
  inputLabel,
  value,
  onValueChange,
  className,
  min = 1,
}: CounterProps) => (
  <div className={cn('grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-2', className)}>
    <Button
      aria-label={decreaseLabel}
      onClick={() => onValueChange(Math.max(min, value - 1))}
      size="sm"
      variant="secondary"
    >
      <MinusIcon />
    </Button>
    <Input
      aria-label={inputLabel}
      className="w-full [appearance:textfield] text-center [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
      inputMode="numeric"
      min={min}
      onChange={e => onValueChange(Number(e.currentTarget.value))}
      type="number"
      value={value}
    />
    <Button aria-label={increaseLabel} onClick={() => onValueChange(value + 1)} size="sm" variant="secondary">
      <PlusIcon />
    </Button>
  </div>
)
